import React, { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import noteContext from "../context/notes/noteContext";

const AddNote = (props) => {
  let navigate = useNavigate();
  document.title = props.title;
  useEffect(() => {
    props.showLoading()
    if(!localStorage.getItem('auth-token')){
      navigate('/auth/login')
    }
    setTimeout(()=>{
      props.completeLoading()
    },100)
  }, [])
  const context = useContext(noteContext);
  const { addNote } = context;
  
  const [note, setNote] = useState({ title: "", description: "" });
  const onChange = (e) => {
    setNote({ ...note, [e.target.name]: e.target.value });
  };
  const handleAddNoteBtn = (e) => {
    e.preventDefault();
    if (note.title !== "" && note.description !== "") {
      let selectedTag = document.getElementById("tag");
      if (selectedTag.value !== "") {
        let tag =
          selectedTag.value.substr(0, 1).toUpperCase() +
          selectedTag.value.slice(1);
        addNote(note.title, note.description, tag);
      } else {
        addNote(note.title, note.description);
      }
      navigate('/')
    }
  };
  return (
    <div
      className={`container px-5 my-4 ${
        props.theme === "dark" ? "text-light" : ""
      }`}
    >
      <span className="float-end">Fields with (<span className="text-danger">*</span>) are required</span>
      <h1 className="text-center">Add Note</h1>
      <form onSubmit={handleAddNoteBtn}>
        <div className="mb-3">
          <label htmlFor="title" className="form-label">
            Enter Note Title<span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${
              props.theme === "dark" ? "bg-dark text-light" : ""
            }`}
            id="title"
            name="title"
            aria-describedby="emailHelp"
            onChange={onChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="description" className="form-label">
            Enter Note Description<span className="text-danger">* </span><span className="text-secondary"> (Min. 4 characters)</span>
          </label>
          <textarea
            rows={5}
            type="text"
            className={`form-control ${
              props.theme === "dark" ? "bg-dark text-light" : ""
            }`}
            id="description"
            minLength={4}
            name="description"
            onChange={onChange}
            required
          ></textarea>
        </div>
        <select
          className={`form-select form-select-lg mb-3 ${
            props.theme === "dark" ? "bg-dark text-light" : ""
          }`}
          name="tag"
          defaultValue={""}
          id="tag"
          aria-label=".form-select-lg example"
        >
          <option value="">Choose Tag For Note</option>
          <option value="general">General</option>
          <option value="personal">Personal</option>
          <option value="official">Official</option>
          <option value="others">Others</option>
        </select>
          <button
            type="submit"
            className="btn btn-primary"
          >
            Add Note
          </button>
      </form>
    </div>
  );
};

export default AddNote;
